import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';

export const Info = ({
	tooltip,
	children,
}) => {
	return (
		<div
			title = {tooltip}>
			{children}
			<i className = {'bi-info-circle ml-1'} style = {{color: '#0056b3'}}/>
		</div>
	);
};

export const Item = ({
	label,
	value,
	valueClasses = '',
	labelTooltip,
}) => {
	label = <b>{`${label}:`}</b>;
	if (labelTooltip) {
		label = <Info
			tooltip = {labelTooltip}>
			{label}
		</Info>
	}

	return (
		<ListGroup.Item>
			<Container>
				<Row>
					<Col className = 'col-4'>
						{label}
					</Col>
					<Col className = {valueClasses}>
						{value || ''}
					</Col>
				</Row>
			</Container>
		</ListGroup.Item>
	);
};
